import React, { FC } from 'react';
import { Route, RouteProps } from 'react-router-dom';

import { useHasRole, useProfile } from 'hooks';

import Page403 from './Page403';

export const ProtectedRoute: FC<RouteProps> = ({ path, ...props }) => {
  const { profile } = useProfile();

  const canClaimWithRole = useHasRole(profile, String(path));

  if (canClaimWithRole) {
    return <Route path={path} {...props} />;
  } else {
    return (
      <Route path='*'>
        <Page403 />
      </Route>
    );
  }
};
